import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { AuthProvider } from './auth/AuthContext.js';
import './estilos/tokens.css';
import './estilos/base.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Elemento #root nao encontrado no index.html');
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Catálogo e classes mudam por importação, não a cada segundo.
      staleTime: 30_000,
      // O cliente de API já renova a sessão sozinho; repetir um 401/403 aqui só
      // multiplicaria requisição inútil.
      retry: (falhas, erro) => {
        const codigo = (erro as { code?: string }).code;
        if (codigo !== undefined && codigo.startsWith('AUTH_')) return false;
        return falhas < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
